<template>
  <section class="sec-top-intro">
    <!-- <div class="top-recom">
      <img src="@/assets/img/mainimg-33.jpg" class="only_pc" />
      <img src="@/assets/img/sp-mainimg-33.jpg" class="only_sp" />
    </div> -->
    <div class="box-top-slide">
      <div class="img-top-slide">
        <div id="slide" class="img-top-slide-in">
          <figure class="item is-active"><a href="/web/assets/202511_vdcampaign.png"><img src="@/assets/img/top_slider_202511_vdcampaign.png"></a></figure>
          <figure class="item"><a href="https://docs.google.com/viewer?url=https://www.manavis-cosme.co.jp/web/contents/library/pdf/campaign-information/ecoproject05.pdf"><img src="@/assets/img/top_slider_ecoproject05.jpg"></a></figure>
          <figure class="item"><img src="@/assets/img/top_slider_202512_manavisfesta.jpg"></figure>
          <figure class="item"><a href="https://docs.google.com/viewer?url=https://www.manavis-cosme.co.jp/web/contents/library/pdf/leaflet/flora_202510.pdf"><img src="@/assets/img/top_slider_202510_flora.jpg"></a></figure>
          <figure class="item"><router-link to="/lp/vitamin-d-plus"><img src="@/assets/img/top_slider_vitamin-d.jpg"></router-link></figure>
          <figure class="item"><a href="/web/assets/202504_acseries.jpg"><img src="@/assets/img/top_slider_202504_acseries.jpg"></a></figure>
          <figure class="item"><a href="/web/contents/library/campaign-information/index.html"><img src="@/assets/img/top_slider_202504_ouencampaign2.jpg"></a></figure>
          <figure class="item"><a href="https://www.manavis-cosme.co.jp/web/contents/library/img/campaign-information/20250401_birthdaycampaign.jpg"><img src="@/assets/img/top_slider_202504_birthdaycampaign.jpg"></a></figure>
          <figure class="item"><router-link to="/lp/msc-seminar-2023"><img src="@/assets/img/msc_seminar_2023_banner_3.jpg"></router-link></figure>
          <figure class="item"><router-link to="/lp/supplementplus202501"><img src="@/assets/img/top_slider_supplementplus2.jpg"></router-link></figure>
          <figure class="item"><router-link to="/lp/homeicon"><img src="@/assets/img/top_slider_homeicon.jpg"></router-link></figure>
        </div>
        <!-- ◯のナビを追加 -->
        <div id="slide-nav" class="slide-nav"></div>
      </div>
    </div>
  </section>

  <section>
    <div class="top_news" v-if="shopping">
      <h2>お知らせ</h2>
      <!-- <img src="@/assets/img/information.png" style="width: 100px" /> -->
      <!-- 最新10件表示 -->
      <div class="news_section">
        <dl class="list-news">
          <template v-for="(info, i) in informationsForShopping" :key="i">
            <dt>{{ info.date }}</dt>
            <dd v-html="info.html" />
          </template>
        </dl>
      </div>
    </div>
    <div class="box-p-20 text-center" v-if="shopping">
      <router-link to="/archives" class="btn d-inline-block">
        過去記事一覧へ
      </router-link>
    </div>
    <div class="top_news" v-if="!shopping">
      <h2>会員通信</h2>
      <!-- <img src="@/assets/img/information.png" style="width: 100px" /> -->
      <!-- 最新10件表示 -->
      <div class="news_section">
        <dl class="list-news">
          <template v-for="(info, i) in informationsForGeneral" :key="i">
            <dt>{{ info.date }}</dt>
            <dd v-html="info.html" />
          </template>
        </dl>
      </div>
    </div>
    <div class="box-p-20 text-center" v-if="!shopping">
      <router-link to="/archives" class="btn d-inline-block">
        過去記事一覧へ
      </router-link>
    </div>
    <div class="top_news" v-if="!shopping">
      <h2>ビューティーコラム</h2>
      <div class="column_section d-flex flex-wrap justify-content-between">
        <div class="column_item">
            <router-link to="/column/column-202509-2"><img src="@/assets/img/column/column_202509-2.jpg" alt="202509" /></router-link>
            <h3>見た目ケア外側だけで大丈夫？</h3>
            <p>2人に1人が期待する"骨の健康維持"による美容効果<br>忘れがちな「美容と骨の関係」に注目</p>
            <div class="text-center mt-5">
              <router-link to="/column/column-202509-2" class="btn">
                コラムを読む
              </router-link>
            </div>
        </div>
        <div class="column_item">
            <router-link to="/column/column-202509"><img src="@/assets/img/column/column_202509.jpg" alt="202508" /></router-link>
            <h3>乾燥の正体は“夏疲れ”かも。</h3>
            <p>9月から始める秋枯れ肌リセット美容。夏疲れが忍び寄る秋の肌、あなたは対策してる？乾燥対策の新常識 “多層的なうるおい”スキンケア。1日で大事な保湿タイム。せっかくなら、表面から内側まで隅々にうるおいを届ける“レイヤー保湿”がおすすめです。</p>
            <div class="text-center mt-5">
              <router-link to="/column/column-202509" class="btn">
                コラムを読む
              </router-link>
            </div>
        </div>
        <div class="column_item">
            <router-link to="/column/column-2025special"><img src="@/assets/img/column/column_2025special.jpg" alt="2025special" /></router-link>
            <h3>ビタミンDと美容効果の関係</h3>
            <p>98%の日本人が足りてないといわれる、ビタミンD。実は美容効果の高い美肌の栄養素って知ってますか？</p>
            <div class="text-center mt-5">
              <router-link to="/column/column-2025special" class="btn">
                コラムを読む
              </router-link>
            </div>
        </div>
      </div>
    </div>
    <div class="box-p-20 text-center" v-if="!shopping">
      <a href="/web/contents/library/beauty-column/index.html" class="btn d-inline-block">
        過去記事一覧へ
      </a>
    </div>
    <div v-if="isManager_J" class="top_news">
      <h2>マネージャー専用情報</h2>
      <!-- <img src="@/assets/img/information.png" style="width: 100px" /> -->
      <!-- 最新10件表示 -->
      <div class="news_section">
        <dl class="list-news">
          <template v-for="(info, i) in informationsForManager" :key="i">
            <dt>{{ info.date }}</dt>
            <dd v-html="info.html" />
          </template>
        </dl>
      </div>
    </div>
    <div v-if="isManager_J" class="box-p-20 text-center">
      <router-link to="/archives" class="btn d-inline-block"
        >過去記事一覧へ</router-link
      >
    </div>
  </section>

  <section class="mt-5">
    <div class="d-flex flex-wrap">
      <div class="category_card">
        <router-link to="/products"
          ><img src="@/assets/img/cart.png" alt="ご注文"
        /></router-link>
      </div>
      <div class="category_card">
        <router-link to="/histories"
          ><img src="@/assets/img/histories.png" alt="購入履歴"
        /></router-link>
      </div>
      <div class="category_card" v-if="!shopping">
        <router-link to="/results"
          ><img src="@/assets/img/results.png" alt="実績確認"
        /></router-link>
      </div>
      <div class="category_card" v-if="!shopping">
        <router-link to="/results/tree"
          ><img src="@/assets/img/tree.png" alt="組織図"
        /></router-link>
      </div>
      <div class="category_card">
        <a href="/web/contents/library/index.html"
          ><img src="@/assets/img/library.png" alt="ライブラリ"
        /></a>
      </div>
      <div class="category_card">
        <router-link to="/pointhistories"><img src="@/assets/img/point.png" alt="ポイント" /></router-link>
      </div>
      <div class="category_card">
        <router-link to="/settings"
          ><img src="@/assets/img/settings.png" alt="設定"
        /></router-link>
      </div>
      <!-- ショッピング会員は非表示、押下時に「月次ボーナス明細」ページを当月で検索状態にする -->
      <div class="category_card" v-if="!shopping">
        <router-link to="/details"
          ><img src="@/assets/img/details.png" alt="ボーナス明細"
        /></router-link>
      </div>
    </div>
  </section>

  <section class="app_get only_sp mt-5">
    <div class="d-flex justify-content-around">
      <img src="@/assets/img/appstore.png" alt="AppStore" />
      <img src="@/assets/img/google-play-badge.png" alt="GooglePlay" />
    </div>
  </section>
</template>

<script>
import axios from "axios";
import $ from "jquery";
import Authenticate from "@/modules/Authenticate";
let auth = new Authenticate();

export default {
  data() {
    return {
      informations: [],
      informationsForManager: [],
      informationsForShopping: [],
      informationsForGeneral: [],
      shopping: true,
      timer:false,
    };
  },
  computed: {
    isManager() {
      return this.$store.state.isManager;
    },
    isManager_J(){
      return this.$store.state.isManager_J;
    }
  },
  mounted() {
    var today = new Date(Date.now());
    var targetDay = new Date(2022, 11, 29, 16 , 0, 0)
    console.log("now:"+today)
    console.log("targetDay:"+targetDay)
    this.timer = today > targetDay
    console.log("timer:"+this.timer)
    window.scroll(0, 0);
    this.shopping = auth.getShopping();
    axios
      .get(process.env.VUE_APP_CONTENTS_INFORMATION_HOME + "index.json?"+new Date().getTime())
      .then((res) => {
        let forManager = res.data.filter(function (info) {
          return (info.isManager);
        });
        let forShopping = res.data.filter(function (info) {
          return (info.isShopping);
        });
        let forGeneral = res.data.filter(function (info) {
          if(!(info.isManager || info.isShopping)) {
            return true;
          }else{
            return false;
          }
        });
        this.informationsForManager = forManager.slice(0, 3);
        this.informationsForShopping = forShopping.slice(0, 3);
        this.informationsForGeneral = forGeneral.slice(0, 3);
      })
      .catch(() => {
        console.log("お知らせが読み取れません");
      });
    $(function(){
        var imgs = $('#slide .item');
        var imgLen = imgs.length;
        var count = 0;
        var nav = $('#slide-nav');
        var timerId;

        nav.empty();

        // スライド切替関数
        function showSlide(index) {
          count = index % imgLen;
          imgs.removeClass('is-active').eq(count).addClass('is-active');
          nav.find('button').removeClass('active').eq(count).addClass('active');
        }
        // 自動切替関数
        function startTimer() {
          timerId = setInterval(function(){
            showSlide(count + 1);
          }, 2500);
        }

        // ナビ用ボタン生成
        imgs.each(function(i){
          var btn = $('<button>').on('click', function(){
            // スライド表示
            showSlide(i);

            // タイマーをリセット
            clearInterval(timerId);
            startTimer();
          });
          if(i === 0) btn.addClass('active');
          nav.append(btn);
        });

        // 最初のスライド＆タイマー開始
        showSlide(0);
        startTimer();
      });
  },
};
</script>

<style scoped>
/* トップMV */
.top-recom img {
  width: 100%;
  margin: 0 auto;
}
/* トップスライダー */
.box-top-slide .txt-top-slide {
  position: absolute;
  top: 120px;
  left: 50%;
  letter-spacing: 4px;
  line-height: 2;
  font-size: 30px;
  transform: translateX(-50%);
  z-index: 1;
}
.img-top-slide-in {
  position: relative;
}
.img-top-slide-in:before {
  content: "";
  display: block;
  padding-top: 56.25%;
}
.img-top-slide-in .item {
  opacity: 0;
  position: absolute;
  transition: opacity 1.5s ease-in-out;
  pointer-events: none;
  top: 0;
}
.img-top-slide-in .item.is-active {
  opacity: 1;
  pointer-events: auto;
}
.img-top-slide .item img {
  width: 100%;
  height: auto;
}
.sec-top-intro .txt-top-01,
.sec-top-intro .txt-top-02 {
  text-align: center;
}
.sec-top-intro .txt-top-01 {
  margin: 100px 0 40px;
  letter-spacing: 2px;
  font-size: 20px;
}
.sec-top-intro .txt-top-02 {
  margin-bottom: 20px;
  line-height: 2.28;
}

#slide-nav {
  display: flex;
  justify-content: center;
  margin-top: 15px;
  gap: 8px;
}

/* 会員通信 */
.top_news {
  padding: 20px;
}
.top_news h2 {
  text-align: left;
  border-bottom: 1px solid #eee;
  margin-bottom: 0;
  line-height: 10vh;
  font-size: 35px;
}
.top_news img {
  width: 100px;
}
.top_news .btn {
  min-width: 130px;
}
.top_news .news_section {
  width: 100%;
}
.list-news dt {
  float: left;
  width: 120px;
  padding-top: 17px;
  letter-spacing: 0.1em;
  font-family: "proxima-nova", sans-serif;
}
.list-news dd {
  padding: 17px 0 17px 150px;
  border-bottom: 1px solid #eee;
}
/* トップカテゴリー */
.category_card {
  display: flex;
  flex-direction: column;
  width: 25%;
}
.category_card img {
  width: 100%;
}
.app_get {
  padding: 20px;
}
.app_get img {
  width: 50%;
  height: 100%;
}
.lineup_title {
  display: flex;
  align-items: center;
  height: 5vh;
  padding-left: 20px;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  clear: both;
}
@media screen and (min-width: 1px) and (max-width: 991px) {
  .list-news dt {
    width: 100%;
  }

  .list-news dd {
    padding: 0 0 15px;
  }
  .top_news .btn {
    margin-top: 3rem;
  }
}
@media screen and (min-width: 1px) and (max-width: 699px) {
  .category_card {
    width: 50%;
  }
  .sec-top-intro {
    margin: 0 -15px;
  }
}

/* ビューティーコラム */
.column_section .column_item {
    width: calc(33.33% - 10px);
    text-align: center;
    padding-top: 17px;
}
.column_section .column_item h3 {
  margin: 15px 0;
}
.column_section .column_item img {
  width: 100% !important;
}
@media screen and (min-width: 1px) and (max-width: 768px) {
  .column_section .column_item {
      width: 100%;
      padding-bottom: 17px;
  }
}
</style>
<style>
#slide-nav button {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: none !important;
  background-color: #ccc;
  cursor: pointer;
  transition: background-color 0.3s;
  padding: inherit;
}
#slide-nav button.active {
  background-color: #333 !important;
}
</style>